/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

//import images
import { assetImages } from "constants";

//import current date
import { getCurrentDateInString } from "helper/getcurrentdatestring";
import { reactSelectStyle } from "Config/Config";

const EventProductPopup = ({
  eventProductId,
  afterPopupClose = () => {},
  eventId,
}) => {
  const token = localStorage.getItem("token");

  const [selectedEventProductId, setSelectedEventProductId] =
    useState(eventProductId); // when a product is selected

  const [productInputName, setProductInputName] = useState("");
  const [selectedProductId, setSelectedProductId] = useState(""); // when a product is
  const [selectedProductDetails, setSelectedProductDetails] = useState({}); // when a product is selected

  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [productValue, setProductValue] = useState(null); // for selected product in dropdown
  const [optionsToShow, setOptionsToShow] = useState([]); // options for the dropdown

  const [isFetchingDetails, setIsFetchingDetails] = useState(false); // Track loading state for product details

  //function for get details of event member
  const getEventProductDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_EVENT_PRODUCT_DETAILS +
        `/${eventProductId}?token=${token}`;

      const response = await getData(requestUrl);
      console.log("getEventProductDetails response --------> ", response);

      if (response.status) {
        const eventProduct = response.data;

        if (eventProduct) {
          setSelectedProductId(eventProduct.product._id);
          setSelectedProductDetails(eventProduct.product);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // add product to event
  const addProductToEventHandler = async () => {
    setIsSaving(true); // Start loading
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_ADD_EVENT_PRODUCTS +
        `/${eventId}?token=${token}`;

      const data = {
        productid: selectedProductId,
      };

      const response = await postData(requestUrl, data);
      console.log("response add product to event --------> ", response);

      if (response.status) {
        setIsSaving(false); // Stop loading
        let offCanvasPopup = document.querySelector("#offcanvasEventProduct");
        let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
        offCanvas.hide();

        afterPopupClose();
      }
    } catch (error) {
      console.log(error.message);
      setIsSaving(false); // Stop loading
    }
  };

  // remove product from event
  const removeProductFromEventHandler = async () => {
    setIsSaving(true); // Start loading
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_UPDATE_EVENT_PRODUCTS +
        `/${eventProductId}?token=${token}`;

      const data = {
        status: "0",
      };

      const response = await putData(requestUrl, data);

      console.log("response remove product from event --------> ", response);
      if (response.status) {
        let offCanvasPopup = document.querySelector("#offcanvasEventProduct");
        let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
        offCanvas.hide();

        afterPopupClose();
      }
      setIsSaving(false); // Stop loading
    } catch (error) {
      console.log(error.message);
      setIsSaving(false); // Stop loading
    }
  };

  // function to get products by query, on search
  const getProductsByQuery = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_PRODUCTS_BY_QUERY +
        `?token=${token}&name=${productInputName}`;

      console.log("requestUrl --------> ", requestUrl);

      const response = await getData(requestUrl);

      console.log("response products by query --------> ", response);

      if (response.status) {
        // Ensure the data is mapped correctly for the Select component
        const formattedOptions = response.data.map((product) => ({
          label: product.label,
          value: product.value,
        }));
        setOptionsToShow(formattedOptions);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // function to handle product selection
  const productSelectionHandler = (val) => {
    console.log("productSelectionHandler --------> ", val);
    if (val) {
      setSelectedProductId(val.value);
      setProductValue(val);
    } else {
      setSelectedProductId("");
      setProductValue(null);
    }
  };

  // function to get product details by ID
  const getProductDetailsById = async () => {
    try {
      setIsFetchingDetails(true); // Start loading
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_PRODUCT_DETAILS +
        `/${selectedProductId}?token=${token}`;

      const response = await getData(requestUrl);

      console.log("response product details by id --------> ", response);

      if (response.status) {
        setSelectedProductDetails(response.data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsFetchingDetails(false); // Stop loading
    }
  };

  // useEffect to fetch product details when a product is selected
  useEffect(() => {
    console.log("selectedProductId --------> ", selectedProductId);
    setSelectedProductDetails({}); // Reset the selected product details when the ID changes

    if (selectedProductId) {
      getProductDetailsById(selectedProductId);
    }
  }, [selectedProductId]);

  //function for after close popup
  const closePopupHandler = () => {
    setSelectedProductId("");
    setSelectedProductDetails({});
    setProductValue(null);
    setOptionsToShow([]);
  };

  useEffect(() => {
    if (productInputName.length > 2) {
      getProductsByQuery();
    }
  }, [productInputName]);

  useEffect(() => {
    if (eventProductId) {
      setSelectedEventProductId(eventProductId);
    } else {
      setSelectedEventProductId("");
    }
  }, [eventProductId]);

  // get product details if a product is selected
  useEffect(() => {
    if (selectedEventProductId) {
      getEventProductDetails();
    }
  }, [selectedEventProductId]);

  return (
    <div
      className="offcanvas md offcanvas-end bg-white border-0"
      tabIndex="-1"
      id="offcanvasEventProduct"
      aria-labelledby="offcanvasEventProductLabel"
    >
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              inventory_2
            </span>
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasInitialOfferCustomerLabel"
            >
              Product Details
            </h3>
            <p className="text-white fs-sm mb-0">
              Manage product details for this event
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={() => {
            closePopupHandler();
            afterPopupClose();
          }}
        ></button>
      </div>

      <div className="offcanvas-body d-flex flex-column justify-content-between p-4">
        <div>
          {!eventProductId && (
            <div className="p-3 p-sm-4 rounded-10 border mb-4">
              <h3 className="mb-3">Add Product to Event</h3>
              <Select
                isClearable
                className="w-100"
                placeholder="Search by product name"
                options={optionsToShow}
                value={productValue}
                onChange={(val) => {
                  productSelectionHandler(val);
                }}
                onInputChange={(val) => {
                  setProductInputName(val);
                }}
                styles={reactSelectStyle("3px", "6px", true, false)}
              />
            </div>
          )}

          {/* Product Details with name, sku and status */}
          {isFetchingDetails ? (
            <div className="d-flex align-items-center gap-3 p-3 p-sm-4 rounded-10 shadow-sm mb-4 placeholder-glow">
              <div
                className="rounded-5 overflow-hidden bg-secondary placeholder"
                style={{ width: "65px", height: "65px" }}
              ></div>
              <div>
                <h3
                  className="mb-2 placeholder bg-secondary"
                  style={{ width: "150px", height: "20px" }}
                ></h3>
                <ul className="list-inline d-flex gap-3 align-items-center mb-0">
                  <li
                    className="d-inline-block px-2 py-1 bg-secondary placeholder"
                    style={{ width: "50px", height: "20px" }}
                  ></li>
                  <li>
                    <span
                      className="placeholder bg-secondary"
                      style={{ width: "100px", height: "20px" }}
                    ></span>
                  </li>
                </ul>
              </div>
            </div>
          ) : (
            selectedProductId &&
            selectedProductDetails && (
              <div className="d-flex align-items-center border gap-3 p-3 p-sm-4 rounded-10 shadow-sm mb-4">
                <div
                  className="rounded-5 overflow-hidden"
                  style={{ width: "65px", height: "65px" }}
                >
                  <img
                    src={
                      selectedProductDetails?.productimagepath === ""
                        ? "assets/img/headache-pill-tablets.png"
                        : url.SERVER_URL +
                          selectedProductDetails?.productimagepath
                    }
                    alt={selectedProductDetails.name}
                    className="w-100 h-100 object-fit-cover object-center"
                  />
                </div>
                <div>
                  <h3 className="mb-2">{selectedProductDetails.name}</h3>
                  <ul className="list-inline d-flex gap-3 align-items-center mb-0">
                    <li className="d-inline-block px-2 py-1 bg-success fs-sm lh-1 text-white rounded-90">
                      Active
                    </li>
                    <li>
                      SKU:{" "}
                      <span className="text-primary">
                        {selectedProductDetails.sku}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            )
          )}

          {/* Product Details with summary, category, company, units available and price */}
          {isFetchingDetails ? (
            <div className="p-3 p-sm-4 rounded-10 border mb-4 placeholder-glow">
              <h3
                className="mb-3 placeholder bg-secondary"
                style={{ width: "200px", height: "20px" }}
              ></h3>
              <div className="row mb-3">
                <div className="mb-3 mb-sm-0">
                  <p
                    className="text-gray mb-0 placeholder bg-secondary"
                    style={{ width: "100px", height: "15px" }}
                  ></p>
                  <p
                    className="fw-normal placeholder bg-secondary"
                    style={{ width: "300px", height: "15px" }}
                  ></p>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-sm-6 mb-3 mb-sm-0">
                  <p
                    className="text-gray mb-0 placeholder bg-secondary"
                    style={{ width: "100px", height: "15px" }}
                  ></p>
                  <span
                    className="fw-normal placeholder bg-secondary"
                    style={{ width: "150px", height: "15px" }}
                  ></span>
                </div>
                <div className="col-sm-6">
                  <p
                    className="text-gray mb-0 placeholder bg-secondary"
                    style={{ width: "100px", height: "15px" }}
                  ></p>
                  <p
                    className="fw-semibold placeholder bg-secondary"
                    style={{ width: "150px", height: "15px" }}
                  ></p>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 mb-3 mb-sm-0">
                  <p
                    className="text-gray mb-0 placeholder bg-secondary"
                    style={{ width: "100px", height: "15px" }}
                  ></p>
                  <p
                    className="fw-semibold placeholder bg-secondary"
                    style={{ width: "150px", height: "15px" }}
                  ></p>
                </div>
                <div className="col-sm-6">
                  <p
                    className="text-gray mb-0 placeholder bg-secondary"
                    style={{ width: "100px", height: "15px" }}
                  ></p>
                  <p
                    className="fw-semibold text-success placeholder bg-secondary"
                    style={{ width: "150px", height: "15px" }}
                  ></p>
                </div>
              </div>
            </div>
          ) : (
            selectedProductId &&
            selectedProductDetails && (
              <div className="p-3 p-sm-4 rounded-10 border mb-4">
                <h3 className="mb-3">Details Of the Product</h3>
                <div className="row mb-3">
                  <div className="mb-3 mb-sm-0">
                    <p className="text-gray mb-0">Summary</p>
                    <p className="fw-normal">
                      {selectedProductDetails.summary}
                    </p>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-sm-6 mb-3 mb-sm-0">
                    <p className="text-gray mb-0">Category</p>
                    {selectedProductDetails.categoryidlist &&
                      selectedProductDetails.categoryidlist.map((category) => (
                        <span className="fw-normal" key={category._id}>
                          {category.name} {", "}
                        </span>
                      ))}
                  </div>
                  <div className="col-sm-6">
                    <p className="text-gray mb-0">Company</p>
                    <p className="fw-semibold">
                      {selectedProductDetails.companyname}
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6 mb-3 mb-sm-0">
                    <p className="text-gray mb-0">Units Availables</p>
                    <p className="fw-semibold">
                      {selectedProductDetails.stock}
                    </p>
                  </div>
                  <div className="col-sm-6">
                    <p className="text-gray mb-0">Price</p>
                    <p className="fw-semibold text-success">
                      €{selectedProductDetails.price}
                    </p>
                  </div>
                </div>
              </div>
            )
          )}
        </div>

        <div className="action d-flex flex-wrap gap-3">
          {eventProductId &&
            selectedProductDetails &&
            selectedProductDetails.name && (
              <button
                type="button"
                className="btn btn-danger ms-auto d-flex align-items-center gap-2"
                onClick={() => {
                  removeProductFromEventHandler();
                }}
                disabled={isSaving}
                style={{
                  cursor: isSaving ? "not-allowed" : "pointer",
                }}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Removing...
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">
                      delete
                    </span>
                    Remove from Event
                  </>
                )}
              </button>
            )}

          {!eventProductId &&
            selectedProductDetails &&
            selectedProductDetails.name && (
              <button
                type="button"
                className="btn btn-success ms-auto d-flex align-items-center gap-2"
                onClick={() => {
                  addProductToEventHandler();
                }}
                disabled={isSaving}
                style={{
                  cursor: isSaving ? "not-allowed" : "pointer",
                }}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Adding...
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">
                      check_circle
                    </span>
                    Add to Event
                  </>
                )}
              </button>
            )}
        </div>
      </div>
    </div>
  );
};

export default EventProductPopup;
